import * as React from 'react';
import * as _ from 'underscore';

import NumberField from '../../../../_common/platform/tsx/NumberField';
import StringField from '../../../../_common/platform/tsx/StringField';
import NumberSpinner from '../../../../_common/platform/tsx/NumberSpinner';
import NumberSpinnerExtended from '../../../../_common/platform/tsx/NumberSpinnerExtended';
import { ColorBoxField } from '../../../../_common/platform/tsx/ColorBoxField';

import * as appTheme from '../../../../_common/platform/ts/appTheme';

import { CHART_CONSTANT_LINES, chartConstants, SERIES_POINT_SYMBOL } from '../chartConstants';

class ChartCustomStylesFieldRow extends React.Component<any, any> {
    private references: {
        dashStyle?: HTMLElement; // HTMLDivElement;
        colorMethod?: HTMLElement; // HTMLDivElement;
        pointSymbol?: HTMLElement; // HTMLDivElement;
        pointColorMethod?: HTMLElement; // HTMLDivElement;
        labelColorsMethod?: HTMLElement; // HTMLDivElement;
        labelRotationAngleMethod?: HTMLElement; // HTMLDivElement;
        labelPosition?: HTMLElement; // HTMLDivElement;
        labelPositionMethod?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);
    }

    normalize(value) {
        if (value.name == null) {
            delete value.color;
            delete value.colorDefault;
            delete value.colorPalette;
            delete value.indexInPalette;
            delete value.opacity;
            delete value.dashStyle;
            delete value.width;
            delete value.pointSize;
            delete value.pointSymbol;
            delete value.pointColorDefault;
            delete value.pointColor;

            delete value.labelPositionDefault;
            delete value.labelPosition;
            delete value.labelRotationAngleDefault;
            delete value.labelRotationAngle;

            delete value.labelColorsDefault;
            delete value.labelColorBack;
            delete value.labelColorText;
            delete value.labelColorBorder;

            return;
        }

        //LL: wrong
        //if (value.value != null) {
        //    value.value = $.trim(value.value);
        //}

        let find: any;

        find = _.find(CHART_CONSTANT_LINES.dashStyle, function (val) {
            return val.value === value.dashStyle;
        });
        if (find == null) {
            delete value.dashStyle;
        }

        find = _.find(SERIES_POINT_SYMBOL, function (val) {
            return val === value.pointSymbol;
        });
        if (find == null) {
            delete value.pointSymbol;
        }

        //LL: new: use min/max in NumberField
        //LL: use validator appValidators.chartParams.customStyles_Opacity
        //if (value.opacity != null) {
        //    if (value.opacity > 1 || value.opacity < 0) {
        //        value.opacity = 0.5;
        //    }
        //}
    }

    processNameChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.name = val;
        this.handleValueChange(obj);
    };
    processNameClick = (e) => {
        let obj = _.clone(this.props.value || {});
        obj.name = '';
        this.handleValueChange(obj);
    };

    processOpacityChange = (val) => {
        //LL: use validator appValidators.chartParams.customStyles_Opacity
        //if (val > 1 || val < 0) {
        //    return;
        //}

        let obj = _.clone(this.props.value || {});
        obj.opacity = val;
        this.handleValueChange(obj);
    };

    processDashStyleChange = (e) => {
        let val = (this.references.dashStyle as HTMLInputElement).value;
        let obj = _.clone(this.props.value || {});
        obj.dashStyle = val;
        this.handleValueChange(obj);
    };

    processWidthChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.width = val;
        this.handleValueChange(obj);
    };

    processColorChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.color = val;
        this.handleValueChange(obj);
    };

    processPaletteIndexChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.indexInPalette = val;
        this.handleValueChange(obj);
    };

    processColorMethodChange = (e) => {
        let val = (this.references.colorMethod as HTMLInputElement).value;

        let obj = _.clone(this.props.value || {});
        obj.colorMethod = val;

        //LL:  set values of old functionality:
        switch (val) {
            case 'automatic': // = old "default"
                obj.colorDefault = true;
                obj.colorPalette = false;
                break;
            case 'indexInPalette':
                obj.colorDefault = false;
                obj.colorPalette = true;
                break;
            case 'chooseColor':
                obj.colorDefault = false;
                obj.colorPalette = false;
                break;
        }

        this.handleValueChange(obj);
    };

    processPointSizeChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.pointSize = val;
        this.handleValueChange(obj);
    };

    processPointSymbolChange = (e) => {
        let val = (this.references.pointSymbol as HTMLInputElement).value;
        let obj = _.clone(this.props.value || {});
        obj.pointSymbol = val;
        this.handleValueChange(obj);
    };

    processPointColorChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.pointColor = val;
        this.handleValueChange(obj);
    };
    processPointColorMethodChange = (e) => {
        let val = (this.references.pointColorMethod as HTMLInputElement).value;

        let obj = _.clone(this.props.value || {});
        obj.pointColorMethod = val;

        switch (val) {
            case 'automatic': // = old "default"
                obj.pointColorDefault = true;
                break;
            case 'chooseColor':
                obj.pointColorDefault = false;
                break;
        }

        this.handleValueChange(obj);
    };

    processLabelColorBackChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.labelColorBack = val;
        this.handleValueChange(obj);
    };
    processLabelColorTextChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.labelColorText = val;
        this.handleValueChange(obj);
    };
    processLabelColorBorderChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.labelColorBorder = val;
        this.handleValueChange(obj);
    };
    processLabelColorsMethodChange = (e) => {
        let val = (this.references.labelColorsMethod as HTMLInputElement).value;

        let obj = _.clone(this.props.value || {});
        obj.labelColorsMethod = val;

        switch (val) {
            case 'automatic':
                obj.labelColorsDefault = true;
                break;
            case 'chooseColor':
                obj.labelColorsDefault = false;
                break;
        }

        this.handleValueChange(obj);
    };

    processLabelRotationAngleChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.labelRotationAngle = val;
        this.handleValueChange(obj);
    };
    processLabelRotationAngleMethodChange = (e) => {
        let val = (this.references.labelRotationAngleMethod as HTMLInputElement).value;

        let obj = _.clone(this.props.value || {});
        obj.labelRotationAngleMethod = val;

        switch (val) {
            case 'automatic': // = old "default"
                obj.labelRotationAngleDefault = true;
                break;
            case 'chooseValue':
                obj.labelRotationAngleDefault = false;
                break;
        }

        this.handleValueChange(obj);
    };

    processLabelPositionChange = (e) => {
        let val = (this.references.labelPosition as HTMLInputElement).value;

        let obj = _.clone(this.props.value || {});
        obj.labelPosition = val;
        this.handleValueChange(obj);
    };
    processLabelPositionMethodChange = (e) => {
        let val = (this.references.labelPositionMethod as HTMLInputElement).value;

        let obj = _.clone(this.props.value || {});
        obj.labelPositionMethod = val;

        switch (val) {
            case 'automatic':
                obj.labelPositionDefault = true;
                break;
            case 'chooseValue':
                obj.labelPositionDefault = false;
                break;
        }

        this.handleValueChange(obj);
    };

    handleValueChange(value) {
        this.normalize(value);

        //LL: changed => not inherited
        delete value.inherited;

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    }

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    getRemoveButton(value) {
        if (value.name == null) {
            return;
        }

        if (value.inherited === true) {
            return <span className="glyphicon glyphicon-arrow-down"></span>;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    }

    getName(value) {
        let displayVal = value.name || '';

        if (value.name == null) {
            let displayValEmpty = (
                <button type="button" className="btn btn-default btn-sm" onClick={this.processNameClick}>
                    {'Add'}
                </button>
            );
            return (
                <div className="entity-select">
                    <div className="content">
                        <span className="value">{displayValEmpty}</span>
                    </div>
                </div>
            );
        }

        return (
            <StringField
                onChange={this.processNameChange}
                value={displayVal}
                applyOnEnter={true}
                changeOnBlurOnly={true}
            />
        );
    }

    getOpacity(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.opacity || 0.5;

        return (
            <NumberField
                value={displayVal}
                allowNull={true}
                integer={false}
                min={0}
                max={1}
                applyOnEnter={true}
                onChange={this.processOpacityChange}
            />
        );

        //LL: 18.06.19 TRY    precision = 1 by default
        //return (
        //    <NumberSpinnerExtended
        //        value={ displayVal }
        //        allowNull={ true }
        //        integer={ false }
        //        min={ 0 }
        //        max={ 1 }
        //        step={ 0.1 }
        //        applyOnEnter={ true }
        //        onChange={ this.processOpacityChange }
        //    />
        //);
    }

    getDashStyle(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.dashStyle; // || 'none';

        let options = _.map(CHART_CONSTANT_LINES.dashStyle, function (val) {
            return (
                <option key={val.value} value={val.value}>
                    {val.display}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.dashStyle = input;
                }} //LL: 27.01.25
                className="form-control"
                onChange={this.processDashStyleChange}
                value={displayVal}
            >
                {options}
            </select>
        );
    }

    getWidth(value) {
        if (value.name == null) {
            return;
        }

        return <NumberSpinner value={value.width} onChange={this.processWidthChange} />;
    }

    getColor(value) {
        if (value.name == null) {
            return;
        }

        let indexInPalette = value.indexInPalette;
        if (indexInPalette == null || indexInPalette === 0) {
            indexInPalette = 1;
        }

        let colorPalette = value.colorPalette;
        let colorSimple = !value.colorPalette;
        let colorDefault = value.colorDefault;
        if (colorDefault == null) {
            colorDefault = false;
        } // for old-old configs
        if (colorDefault === true) {
            colorPalette = false;
            colorSimple = false;
        }

        let list = [
            { value: 'automatic', label: 'automatic' }, // = old "default"
            { value: 'indexInPalette', label: 'index in palette' },
            { value: 'chooseColor', label: 'choose color' }
        ];
        let options = _.map(list, function (val) {
            return (
                <option key={val.value} value={val.value}>
                    {val.label}
                </option>
            );
        });

        //let colorMethodVal = value.colorMethod || "automatic";
        //LL: or maybe base on old obj.colorDefault, obj.colorPalette - if not set:
        let colorMethodVal = value.colorMethod;
        if (colorMethodVal == null) {
            if (colorDefault) colorMethodVal = 'automatic';
            else if (colorPalette) colorMethodVal = 'indexInPalette';
            else colorMethodVal = 'chooseColor';
        }

        let selectElem = (
            <select
                ref={(input) => {
                    this.references.colorMethod = input;
                }} //LL: 27.01.25
                className="form-control color-container-colorMethod"
                onChange={this.processColorMethodChange}
                value={colorMethodVal}
            >
                {options}
            </select>
        );

        let rightPaneContent;
        switch (colorMethodVal) {
            case 'automatic': // = old "default"
                break;
            case 'indexInPalette':
                //   title = "color by index in current Palette"
                rightPaneContent = (
                    <NumberSpinnerExtended
                        value={indexInPalette}
                        allowNull={false}
                        integer={true}
                        min={1}
                        onChange={this.processPaletteIndexChange}
                    />
                );
                break;
            case 'chooseColor':
                rightPaneContent = (
                    <ColorBoxField
                        value={value.color}
                        themeObj={this.props.themeObj}
                        hideTransparency={true}
                        showText={false}
                        onChange={this.processColorChange}
                        glob={this.props.glob}
                    />
                );
                break;
        }

        let rightPane = <div className="color-container-pane">{rightPaneContent}</div>;

        return (
            <div className="form-control color-container">
                {selectElem}
                {rightPane}
            </div>
        );
    }

    getPointSize(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.pointSize || 12; //LL: as DevExpress
        return <NumberSpinner value={displayVal} onChange={this.processPointSizeChange} />;
    }

    getPointSymbol(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.pointSymbol || 'circle';

        let options = _.map(SERIES_POINT_SYMBOL, function (val) {
            return (
                <option key={val} value={val}>
                    {val}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.pointSymbol = input;
                }} //LL: 27.01.25
                className="form-control"
                onChange={this.processPointSymbolChange}
                value={displayVal}
            >
                {options}
            </select>
        );
    }

    getPointColor(value) {
        if (value.name == null) {
            return;
        }

        let pointColorDefault = value.pointColorDefault;
        if (pointColorDefault == null) {
            pointColorDefault = true;
        }

        let list = [
            { value: 'automatic', label: 'automatic' }, // = old "default"
            { value: 'chooseColor', label: 'choose color' }
        ];
        let options = _.map(list, function (val) {
            return (
                <option key={val.value} value={val.value}>
                    {val.label}
                </option>
            );
        });

        let pointColorMethodVal = value.pointColorMethod;
        if (pointColorMethodVal == null) {
            pointColorMethodVal = pointColorDefault ? 'automatic' : 'chooseColor';
        }

        let selectElem = (
            <select
                ref={(input) => {
                    this.references.pointColorMethod = input;
                }} //LL: 27.01.25
                className="form-control color-container-colorMethod"
                onChange={this.processPointColorMethodChange}
                value={pointColorMethodVal}
            >
                {options}
            </select>
        );

        let displayVal = value.pointColor || '#5f8b95'; // 1st from palette "default"

        let rightPaneContent;
        switch (pointColorMethodVal) {
            case 'automatic': // = old "default"
                break;
            case 'chooseColor':
                rightPaneContent = (
                    <ColorBoxField
                        value={displayVal}
                        themeObj={this.props.themeObj}
                        hideTransparency={true}
                        showText={false}
                        onChange={this.processPointColorChange}
                        glob={this.props.glob}
                    />
                );
                break;
        }

        let rightPane = <div className="color-container-pane">{rightPaneContent}</div>;

        return (
            <div className="form-control color-container">
                {selectElem}
                {rightPane}
            </div>
        );
    }

    getLabelColors(value) {
        if (value.name == null) {
            return;
        }

        let labelColorsDefault = value.labelColorsDefault;
        if (labelColorsDefault == null) {
            labelColorsDefault = true;
        }

        let list = [
            { value: 'automatic', label: 'automatic' },
            {
                value: 'chooseColor',
                label: 'choose colors (back, text, border)'
            }
        ];
        let options = _.map(list, function (val) {
            return (
                <option key={val.value} value={val.value}>
                    {val.label}
                </option>
            );
        });

        let labelColorsMethodVal = value.labelColorsMethod;
        if (labelColorsMethodVal == null) {
            labelColorsMethodVal = labelColorsDefault ? 'automatic' : 'chooseColor';
        }

        let selectElem = (
            <select
                ref={(input) => {
                    this.references.labelColorsMethod = input;
                }} //LL: 27.01.25
                className="form-control labelColors-container-labelColorsMethod"
                onChange={this.processLabelColorsMethodChange}
                value={labelColorsMethodVal}
            >
                {options}
            </select>
        );

        let displayValBack = value.labelColorBack || chartConstants.defaultPointLabelColorBack; //'white';
        let displayValText = value.labelColorText || chartConstants.defaultPointLabelColorText; //'black';
        let displayValBorder = value.labelColorBorder;

        let rightPaneContent;
        switch (labelColorsMethodVal) {
            case 'automatic':
                break;
            case 'chooseColor':
                rightPaneContent = (
                    <React.Fragment>
                        <span className="color-container-pane">
                            <ColorBoxField
                                value={displayValBack}
                                themeObj={this.props.themeObj}
                                hideTransparency={false}
                                showText={false}
                                onChange={this.processLabelColorBackChange}
                                glob={this.props.glob}
                            />
                        </span>
                        <span className="color-container-pane">
                            <ColorBoxField
                                value={displayValText}
                                themeObj={this.props.themeObj}
                                hideTransparency={false}
                                showText={false}
                                onChange={this.processLabelColorTextChange}
                                glob={this.props.glob}
                            />
                        </span>
                        <span className="color-container-pane">
                            <ColorBoxField
                                value={displayValBorder}
                                themeObj={this.props.themeObj}
                                hideTransparency={false}
                                showText={false}
                                onChange={this.processLabelColorBorderChange}
                                glob={this.props.glob}
                            />
                        </span>
                    </React.Fragment>
                );

                break;
        }

        let rightPane = <div className="labelColors-container-pane">{rightPaneContent}</div>;

        return (
            <div className="form-control labelColors-container">
                {selectElem}
                {rightPane}
            </div>
        );
    }

    getLabelRotationAngle(value) {
        if (value.name == null) {
            return;
        }

        let labelRotationAngleDefault = value.labelRotationAngleDefault;
        if (labelRotationAngleDefault == null) {
            labelRotationAngleDefault = true;
        }

        let list = [
            { value: 'automatic', label: 'automatic' },
            { value: 'chooseValue', label: 'choose value' }
        ];
        let options = _.map(list, function (val) {
            return (
                <option key={val.value} value={val.value}>
                    {val.label}
                </option>
            );
        });

        let labelRotationAngleMethodVal = value.labelRotationAngleMethod;
        if (labelRotationAngleMethodVal == null) {
            labelRotationAngleMethodVal = labelRotationAngleDefault ? 'automatic' : 'chooseValue';
        }

        let selectElem = (
            <select
                ref={(input) => {
                    this.references.labelRotationAngleMethod = input;
                }} //LL: 27.01.25
                className="form-control labelRotationAngle-container-labelRotationAngleMethod"
                onChange={this.processLabelRotationAngleMethodChange}
                value={labelRotationAngleMethodVal}
            >
                {options}
            </select>
        );

        let displayVal = value.labelRotationAngle || chartConstants.defaultPointLabelRotationAngle; // 0;

        let rightPaneContent;
        switch (labelRotationAngleMethodVal) {
            case 'automatic':
                break;
            case 'chooseValue':
                rightPaneContent = (
                    <NumberField
                        value={displayVal}
                        allowNull={true}
                        integer={true}
                        min={-180}
                        max={180}
                        applyOnEnter={true}
                        onChange={this.processLabelRotationAngleChange}
                    />
                );
                break;
        }

        let rightPane = <div className="labelRotationAngle-container-pane">{rightPaneContent}</div>;

        return (
            <div className="form-control labelRotationAngle-container">
                {selectElem}
                {rightPane}
            </div>
        );
    }

    getLabelPosition(value) {
        if (value.name == null) {
            return;
        }

        let labelPositionDefault = value.labelPositionDefault;
        if (labelPositionDefault == null) {
            labelPositionDefault = true;
        }

        let list = [
            { value: 'automatic', label: 'automatic' },
            { value: 'chooseValue', label: 'choose value' }
        ];
        let options = _.map(list, function (val) {
            return (
                <option key={val.value} value={val.value}>
                    {val.label}
                </option>
            );
        });

        let labelPositionMethodVal = value.labelPositionMethod;
        if (labelPositionMethodVal == null) {
            labelPositionMethodVal = labelPositionDefault ? 'automatic' : 'chooseValue';
        }

        let selectElem = (
            <select
                ref={(input) => {
                    this.references.labelPositionMethod = input;
                }} //LL: 27.01.25
                className="form-control labelPosition-container-labelPositionMethod"
                onChange={this.processLabelPositionMethodChange}
                value={labelPositionMethodVal}
            >
                {options}
            </select>
        );

        let displayVal = value.labelPosition || chartConstants.defaultPointLabelPosition; // 'outside';

        let rightPaneContent;
        switch (labelPositionMethodVal) {
            case 'automatic':
                break;
            case 'chooseValue':
                let optionsPos = _.map(['inside', 'outside'], function (val) {
                    return (
                        <option key={val} value={val}>
                            {val}
                        </option>
                    );
                });

                rightPaneContent = (
                    <select
                        ref={(input) => {
                            this.references.labelPosition = input;
                        }} //LL: 27.01.25
                        className="form-control"
                        onChange={this.processLabelPositionChange}
                        value={displayVal}
                    >
                        {optionsPos}
                    </select>
                );

                break;
        }

        let rightPane = <div className="labelPosition-container-pane">{rightPaneContent}</div>;

        return (
            <div className="form-control labelPosition-container">
                {selectElem}
                {rightPane}
            </div>
        );
    }

    getRow0(value) {
        //  only "remove", "name"

        let header;

        let body = (
            <tbody>
                <tr>
                    <td className="cell-remove ">{this.getRemoveButton(value)}</td>
                    <td className="cell-name ">{this.getName(value)}</td>
                </tr>
            </tbody>
        );

        return (
            <table style={{ width: '100%', marginTop: '12px' }}>
                {header}
                {body}
            </table>
        );
    }

    getRow1(value) {
        //  "remove" is empty, without "name"

        let header = (
            <thead>
                <tr>
                    <th className="cell-remove"></th>
                    <th className="cell-color">Color</th>
                    <th className="cell-opacity" title="[0-1], for Areas and Bubble">
                        Opacity
                    </th>
                    <th className="cell-dashStyle" title="for Lines">
                        Dash Style
                    </th>
                    <th className="cell-width" title="for Lines">
                        Width
                    </th>
                    <th className="cell-color" title="for Lines, Scatter, Area">
                        Point Color
                    </th>
                    <th className="cell-pointSymbol" title="for Lines, Scatter, Area">
                        Point Shape
                    </th>
                    <th className="cell-width" title="for Lines, Scatter, Area">
                        Point Size
                    </th>
                </tr>
            </thead>
        );

        let body = (
            <tbody>
                <tr>
                    <td className="cell-remove"></td>
                    <td className="cell-color">{this.getColor(value)}</td>
                    <td className="cell-opacity">{this.getOpacity(value)}</td>
                    <td className="cell-dashStyle">{this.getDashStyle(value)}</td>
                    <td className="cell-width">{this.getWidth(value)}</td>
                    <td className="cell-color">{this.getPointColor(value)}</td>
                    <td className="cell-pointSymbol">{this.getPointSymbol(value)}</td>
                    <td className="cell-width">{this.getPointSize(value)}</td>
                </tr>
            </tbody>
        );

        return (
            <table>
                {header}
                {body}
            </table>
        );
    }

    //LL: not used
    getRow2(value) {
        //  for Point Labels

        //LL: move Colors to Row3, maybe temporary

        let header = (
            <thead>
                <tr>
                    <th className="cell-remove"></th>
                    <th className="cell-labelColors">Point Label Colors</th>
                </tr>
            </thead>
        );

        let body = (
            <tbody>
                <tr>
                    <td className="cell-remove"></td>
                    <td className="cell-labelColors">{this.getLabelColors(value)}</td>
                </tr>
            </tbody>
        );

        //  style={ {marginBottom: "0.5rem"} }  - when last Row
        return (
            <table>
                {header}
                {body}
            </table>
        );
    }

    getRow3(value) {
        //  for Point Labels

        let header = (
            <thead>
                <tr>
                    <th className="cell-remove"></th>
                    <th className="cell-labelColors">Point Label Colors</th>
                    <th className="cell-labelPosition">Label Position</th>
                    <th className="cell-labelRotationAngle" title="-180 : 180">
                        Rotation Angle (dg)
                    </th>
                </tr>
            </thead>
        );

        let body = (
            <tbody>
                <tr>
                    <td className="cell-remove"></td>
                    <td className="cell-labelColors">{this.getLabelColors(value)}</td>
                    <td className="cell-labelPosition">{this.getLabelPosition(value)}</td>
                    <td className="cell-labelRotationAngle">{this.getLabelRotationAngle(value)}</td>
                </tr>
            </tbody>
        );

        return (
            <table style={{ marginBottom: '0.5rem' }}>
                {header}
                {body}
            </table>
        );
    }

    render() {
        let value = this.props.value || {};
        return (
            <tr style={{ borderTop: 'solid #aaaaaa 1px' }}>
                <td className="multiRows">
                    {this.getRow0(value)}
                    {this.props.empty === true ? null : this.getRow1(value)}
                    {this.props.empty === true ? null : this.getRow3(value)}
                </td>
            </tr>
        );
    }
}

function getState() {
    return {};
}

export default class ChartCustomStylesField extends React.Component<any, any> {
    //LL: 27.01.25
    private references: {
        tableBody?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);
    }

    private startIndex;

    reorderStart = (e, ui) => {
        this.startIndex = $(ui.item).index();
    };

    reorderStop = (e, ui) => {
        if (this.startIndex == null) {
            return;
        }

        let startIndex = this.startIndex;
        let stopIndex = $(ui.item).index();

        this.startIndex = null;

        //LL: see: https://gist.github.com/avakhov/7b9d2b1a354e59dbfa63
        //   Вызываем cancel, чтобы элементы местами поменял React.js
        //   $(me.getDOMNode()).sortable("cancel");
        let tableBody = this.references.tableBody;
        $(tableBody).sortable('cancel');

        this.processReorder(startIndex, stopIndex);
    };

    componentDidMount() {
        let tableBody = this.references.tableBody;

        $(tableBody).sortable({
            axis: 'y',
            forceHelperSize: true,
            items: 'tr:not(.empty)',
            opacity: 0.8,
            handle: '.cell-name',
            cursor: 'grabbing',
            start: this.reorderStart,
            stop: this.reorderStop
        });
    }

    componentWillUnmount() {
        let tableBody = this.references.tableBody;
        $(tableBody).sortable('destroy');
    }

    _onChange() {
        this.setState(getState.call(this));
    }

    processReorder(start, stop) {
        if (start === stop) {
            return;
        }

        let value = this.props.value.slice(0);

        let item = value.splice(start, 1);
        value.splice(stop, 0, item[0]);

        this.handleValueChange(value);
    }

    handleValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    addRow = (obj: any) => {
        let arr = this.props.value.slice(0);

        obj.colorDefault = true;
        obj.color = '#5f8b95'; // 1st from palette "default"
        obj.colorPalette = false;
        obj.indexInPalette = 1; // not 0

        obj.opacity = 0.5;
        obj.dashStyle = 'solid'; //  'longDash';
        obj.width = 2; //LL: as DevExpress

        obj.pointSize = 12; //LL: as DevExpress
        obj.pointSymbol = 'circle'; //LL: as DevExpress
        obj.pointColorDefault = true;
        obj.pointColor = '#5f8b95'; // 1st from palette "default"

        obj.labelPositionDefault = true;
        obj.labelPosition = chartConstants.defaultPointLabelPosition; // 'outside';
        obj.labelRotationAngleDefault = true;
        obj.labelRotationAngle = chartConstants.defaultPointLabelRotationAngle; //0;
        //  labelColorsDefault, labelColorsMethod; labelColorBack, labelColorText, labelColorBorder
        obj.labelColorsDefault = true;
        obj.labelColorBack = chartConstants.defaultPointLabelColorBack; // 'white';
        obj.labelColorText = chartConstants.defaultPointLabelColorText; // 'black';
        //obj.labelColorBorder = null;

        arr.push(obj);
        this.handleValueChange(arr);
    };

    changeRow = (obj: any, i) => {
        let arr = this.props.value.slice(0);
        let prev = arr.splice(i, 1, obj)[0];
        this.handleValueChange(arr);
    };

    removeRow = (i) => {
        let arr = this.props.value.slice(0);
        arr.splice(i, 1);
        this.handleValueChange(arr);
    };

    render() {
        let self = this;

        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentvalues(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;

        let rows = _.map(this.props.value, function (obj: any, i) {
            let obj2: any = appTheme.setProperInheritedFlag(obj, ownValues, parentValues, 'ChartCustomStylesField');
            //LL: may be null, if just removed
            if (obj2 == null) {
                return null;
            }

            return (
                <ChartCustomStylesFieldRow
                    key={i + '-' + obj2.name}
                    i={i}
                    value={obj2}
                    themeObj={self.props.themeObj}
                    onChange={self.changeRow}
                    onRemove={self.removeRow}
                    glob={self.props.glob}
                />
            );
        });

        let style1 = { marginBottom: 5 }; // class "table" has margin-bottom:20px

        return (
            <div className={'chartcustomstyles-field'}>
                <div className={'div-container'}>
                    <div className="chartcustomstyles-field-common"></div>
                    <table className={'table' + (this.props.border === true ? ' table-bordered' : '')} style={style1}>
                        <tbody
                            ref={(input) => {
                                this.references.tableBody = input;
                            }} //LL: 27.01.25
                        >
                            {rows}
                            <ChartCustomStylesFieldRow
                                themeObj={this.props.themeObj}
                                onChange={this.addRow}
                                glob={this.props.glob}
                                empty={true}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
